import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import ProductCard from '../components/ProductCard';
import { productAPI } from '../services/api';
import './Products.css';
import { useDocumentMeta } from '../seo/useDocumentMeta';

const CategoryPage = ({ category }) => {
  useDocumentMeta();
  
  const [searchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const result = await productAPI.getProducts({
          category: category
        });
        
        if (result.success) {
          setProducts(result.data);
        } else {
          setError(result.message || 'Failed to fetch products');
        }
      } catch (err) {
        setError('Network error');
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [category]);

  if (loading) {
    return (
      <div className="products-page">
        <div className="loading-container">
          <h2>Loading...</h2>
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="products-page">
        <div className="error-container">
          <h2>Error</h2>
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>Retry</button>
        </div>
      </div>
    );
  }

  return (
    <div className="products-page">
      <div className="products-header">
        <h1>{category}</h1>
        <p>Explore our {category.toLowerCase()} collection</p>
      </div>

      <div className="products-grid">
        {products.map(product => (
          <ProductCard key={product._id} product={product} />
        ))}
      </div>

      {products.length === 0 && !loading && (
        <div className="no-products">
          <h3>No Products Found</h3>
          <p>No products available in this category.</p>
        </div>
      )}
    </div>
  );
};

export default CategoryPage;
